let counter = 0;

function generateId() {
  return `listbox-${counter++}`;
}

//

var script$4 = {
  props: {
    suggestions: {
      type: Array,
      default: () => [],
    },

    value: {
      type: String,
      default: () => "",
    },

    open: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      listboxId: generateId(),
      focusedIndex: null,
    };
  },

  watch: {
    open() {
      this.focusedIndex = null;
    },

    suggestions() {
      this.focusedIndex = null;
    },
  },

  computed: {
    isOpen() {
      return this.open && this.suggestions.length > 0;
    },
  },

  provide() {
    return {
      listboxId: this.listboxId,

      getQuery: () => this.value,
      setQuery: (query) => this.$emit("input", query),

      isOpen: () => this.isOpen,
      getSuggestions: () => this.suggestions,
      selectSuggestion: (suggestion) => this.$emit("selected", suggestion),

      getFocusedIndex: () => this.focusedIndex,
      setFocusedIndex: (index) => (this.focusedIndex = index),
    };
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      attrs: {
        role: "combobox",
        "aria-haspopup": "listbox",
        "aria-expanded": _vm.isOpen,
        "aria-owns": _vm.listboxId + "-suggestions"
      }
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//

var script$3 = {
  inject: ['listboxId'],

  computed: {
    id() {
      return `${this.listboxId}-label`
    }
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("label", { attrs: { id: _vm.id } }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$2 = {
  inject: [
    'listboxId',
    'getSuggestions',
    'isOpen',
    'getFocusedIndex',
    'setFocusedIndex',
    'setQuery',
  ],

  computed: {
    id() {
      return `${this.listboxId}-suggestions`
    },

    labelledById() {
      return `${this.listboxId}-label`
    },
  },

  methods: {
    isFocused(index) {
      return this.getFocusedIndex() === index
    },

    onMouseOut() {
      this.setFocusedIndex(null);
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "ul",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isOpen(),
          expression: "isOpen()"
        }
      ],
      attrs: { id: _vm.id, "aria-labelledby": _vm.labelledById }
    },
    [
      _vm._l(_vm.getSuggestions(), function(suggestion, index) {
        return [
          _vm._t("default", null, {
            suggestion: suggestion,
            index: index,
            isFocused: _vm.isFocused(index)
          })
        ]
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//

var script$1 = {
  props: {
    index: {
      required: true,
      type: Number,
    },

    suggestion: {
      required: true,
      type: String,
    }
  },

  inject: [
    'listboxId',
    'selectSuggestion',
  ],

  computed: {
    id() {
      return `${this.listboxId}-option-${this.index}`;
    },
  },
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "li",
    {
      attrs: { role: "option", id: _vm.id },
      on: {
        click: function($event) {
          return _vm.selectSuggestion(_vm.suggestion)
        }
      }
    },
    [_vm._t("default")],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

//
//
//
//
//
//
//
//
//
//
//

var script = {
  inject: [
    'listboxId',
    'getQuery',
    'setQuery',
    'getSuggestions',
    'selectSuggestion',
    'getFocusedIndex',
    'setFocusedIndex',
  ],

  computed: {
    controlsId() {
      return `${this.listboxId}-suggestions`
    },

    activeDescendantId() {
      if (this.getFocusedIndex() === null) {
        return null
      }

      return `${this.listboxId}-option-${this.getFocusedIndex()}`
    },

    query: {
      get() {
        return this.getQuery()
      },
      set(value) {
        this.setQuery(value);
      }
    }
  },

  methods: {
    onKeydown(evt) {
      switch (evt.key) {
        case "ArrowDown":
          evt.preventDefault();
          this.focusNext();
          break;
        case "ArrowUp":
          evt.preventDefault();
          this.focusPrevious();
          break;
        case "Enter":
          this.selectFocused(evt);
          break;
        case "Escape":
          this.query = "";
          break;
      }
    },

    focusNext() {
      const suggestionsLength = this.getSuggestions().length;

      if (suggestionsLength === 0) {
        return;
      }

      const currentIndex = this.getFocusedIndex();

      if (currentIndex === null) {
        this.setFocusedIndex(0);
      } else {
        // Upon reaching the end of the suggestions, the next focusedIndex will be 0 again.
        this.setFocusedIndex((currentIndex + 1) % suggestionsLength);
      }
    },

    focusPrevious() {
      const suggestionsLength = this.getSuggestions().length;

      if (suggestionsLength === 0) {
        return;
      }

      const currentIndex = this.getFocusedIndex();

      if (currentIndex === null) {
        this.setFocusedIndex(suggestionsLength - 1);
      } else {
        // Upon reaching the beginning of the suggestions, the next focusedIndex will be the last index.
        this.setFocusedIndex((currentIndex + suggestionsLength - 1) % suggestionsLength);
      }
    },

    selectFocused(evt) {
      if (this.getFocusedIndex() === null) {
        return
      }

      evt.preventDefault();
      this.selectSuggestion(this.getSuggestions()[this.getFocusedIndex()]);
    },
  },
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.query,
        expression: "query"
      }
    ],
    attrs: {
      type: "text",
      "aria-autocomplete": "list",
      "aria-controls": _vm.controlsId,
      "aria-activedescendant": _vm.activeDescendantId
    },
    domProps: { value: _vm.query },
    on: {
      keydown: _vm.onKeydown,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.query = $event.target.value;
      }
    }
  })
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

// Declare install function executed by Vue.use()
function install(Vue) {
	if (install.installed) return;
	install.installed = true;
	Vue.component("ComboBox", __vue_component__$4);
  Vue.component("ComboBoxLabel", __vue_component__$3);
	Vue.component("ComboBoxSuggestions", __vue_component__$2);
	Vue.component("ComboBoxSuggestion", __vue_component__$1);
	Vue.component("ComboBoxTextbox", __vue_component__);
}

// Create module definition for Vue.use()
const plugin = {
	install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;

if (typeof window !== 'undefined') {
	GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
	GlobalVue = global.Vue;
}

if (GlobalVue) {
	GlobalVue.use(plugin);
}

export { __vue_component__$4 as ComboBox, __vue_component__$3 as ComboBoxLabel, __vue_component__$1 as ComboBoxSuggestion, __vue_component__$2 as ComboBoxSuggestions, __vue_component__ as ComboBoxTextbox, install };
